import { Injectable, inject } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../core/config/app.config';
import { Observable } from 'rxjs';
import { PermissionsEnum } from './permissions.enum';


@Injectable({ providedIn: 'root' })
export class PermissionService {
  private http = inject(HttpClient);
  private config = inject(AppConfig);


  getAllPermissions(type: string): Observable<any> {
    return this.http.get(this.config.buildUri('permission') + '/AllPermissions?permission=' + type);
  }

  getAllPermissionsGroup(type: string): Observable<any> {
    return this.http.get(this.config.buildUri('permission') + '/AllPermissionsGroup?permission=' + type);
  }

  getAllNavigatorPermissions(withGroup = false): Observable<any> {
    if (withGroup) {
      return this.getAllPermissionsGroup('Navigator');
    }
    return this.getAllPermissions('Navigator');
  }

  getAllManagerPermissions(withGroup = false): Observable<any> {
    if (withGroup) {
      return this.getAllPermissionsGroup('Manager');
    }
    return this.getAllPermissions('Manager');
  }

  getPermissionsPerRole(roleId: number): Observable<any> {
    return this.http.get(this.config.buildUri('permission') + '/PermissionsPerRole?roleId=' + roleId);
  }

  getUserPermissions(): Observable<PermissionsEnum[]> {
    return this.http.get<PermissionsEnum[]>(this.config.buildUri('rolesAndPermissions') + '/GetPermissionsFromAuth0ByUser');
  }
}
